import { BonusDaysValidFromEnum } from '@cyberlabrs/helpers';

export enum LeaveRequestStatus {
    PENDING = 'PENDING',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
}

export enum LeaveRequestType {
    VACATION = 'Vacation',
    MEDICAL_LEAVE = 'Medical Leave',
}

export interface LeaveRequestDto {
    id: string;
    createdAt: string;
    fromDate: string;
    toDate: string;
    policyType: string;
    usedCarriedOverDays?: number;
    status: LeaveRequestStatus;
    userSub: string;
    description?: string;
    rejectReason?: string;
    leaveDurationType: LeaveDurationTypeEnum;
}

export interface MedicalLeaveRequestDto {
    id: string;
    createdAt: string;
    startDate: string;
    endDate: string;
    policyType: string;
    status: LeaveRequestStatus;
    userSub: string;
    description?: string;
    rejectReason?: string;
    leaveDurationType: LeaveDurationTypeEnum;
}

export interface CreateLeaveRequestDto {
    fromDate: string;
    toDate: string;
    type: string;
    description: string;
    leaveDurationType: LeaveDurationTypeEnum;
}

export enum LeaveDurationTypeEnum {
    FULL_DAY = 'FULL_DAY',
    HALF_DAY = 'HALF_DAY',
    FIRST_DAY_HALF = 'FIRST_DAY_HALF',
    SECOND_DAY_HALF = 'SECOND_DAY_HALF',
}

export interface PolicyDto {
    id: string;
    leaveType: string;
    amount: string;
    autoApproved: boolean;
    calculated: boolean;
    addOnJoin: boolean;
    description?: string;
    organizationId: string;
    carriedOverValidToDay: string;
    carriedOverValidToMonth: string;
    colour: string;
    isCarriedOver: boolean;
    maxCarriedOverAmount: number;
    isActive: boolean;
    isRenewable: boolean;
    leaveDescriptionRequired: boolean;
    maximumNegativeAmount: number;
    shortestLeaveDuration: LeaveDurationTypeEnum;
    loyaltyProgramEnabled: boolean;
    bonusEligibilityYears: string;
    bonusDaysAwarded: string;
    bonusDaysValidFrom: BonusDaysValidFromEnum;
    statusLabel: string;
    statusEmoji: string;
}

export type GetAbsentColleaguesCount = {
    absentTodayCount: number;
    absentPeriodCount: number;
};
